export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6408.18786b11.jpg";